module.exports = __webpack_public_path__ + "static/media/bali-bombings-feature-banner-sm@2x.233ce7d2.webp";